import * as types from './actionTypes';

export function clientFilterSet(clientSort: any) {
    return { type: types.SET_CLIENT_FILTER, clientSort };
}
